export const TIME_COMPARISON = [
  {
    label: "Previous Week",
    id: 0,
    value: "Previous Week",
  },
  {
    label: "Previous Month",
    id: 1,
    value: "Previous Month",
  },
  {
    label: "Previous Year",
    id: 2,
    value: "Previous Year",
  },
  {
    label: "OTB",
    id: 4,
    value: "OTB",
  },
];
